<template>
    <div class="ui-popup-place">
        <core-portal :target="target">
            <transition name="ui-popup">
                <div
                    class="ui-popup-wrap"
                    :class="{'ui-popup-wrap--fixed': fixed}"
                    v-if="isShow"
                    @click="onClick"
                >
                    <div class="ui-popup ui-popup--scale">
                        <div class="ui-popup__container" @click.stop>
                            <a class="ui-popup__close" v-if="!hideClose" @click="close">
                                close
                            </a>

                            <div class="ui-popup__body">
                                <slot></slot>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </core-portal>

        <core-portal :target="target">
            <transition name="fade">
                <ui-overlay
                    class="ui-popup__overlay"
                    :class="{'ui-popup__overlay--fixed': fixed}"
                    key="popup"
                    v-if="overlay && isShow"
                    :opacity="0.4"
                    color="#000000"
                />
            </transition>
        </core-portal>
    </div>
</template>

<script>
import CorePortal from '@/components/core/portal'

export default {
    name: 'ui-popup',
    components: {
        CorePortal
    },
    props: {
        hideClose: {
            type: Boolean,
            default: false
        },
        overlay: {
            type: Boolean,
            default: true
        },
        closeOnEsc: {
            type: Boolean,
            default: true
        },
        clickOutsideToClose: {
            type: Boolean,
            default: true
        },
        fixed: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            isShow: false
        }
    },
    computed: {
        target () {
            if (window.innerWidth < 768) {
                return document.body
            } else {
                return this.fixed ? 'body' : '.game'
            }
        }
    },
    methods: {
        onShow () {
            // disabledScroll(true)
        },
        onHide () {
            // disabledScroll(false)
        },
        open () {
            this.isShow = true
            this.$emit('open')
        },
        close () {
            this.isShow = false
            this.$emit('close')
        },
        onClose () {
            this.close()
        },
        onClick () {
            if (this.clickOutsideToClose) {
                this.close()
            }
        }
    },
    beforeDestroy () {
        window.removeEventListener('keyup', this.onEscEvent);
        this.onHide();
    },
    mounted () {
        if (this.closeOnEsc) {
            this.onEscEvent = function (e) {
                if (e.keyCode === 27) {
                    this.close();
                }
            }.bind(this);
            window.addEventListener('keyup', this.onEscEvent);
        }
    }
}
</script>

<style lang="stylus" scoped>
    .ui-popup-wrap {
        text-align center
        position absolute
        top 0
        left 0
        overflow auto
        -webkit-overflow-scrolling touch
        right 0
        bottom 0
        z-index 1150
        transition 0.2s
        line-height 100%

        +layout-sm() {
            position fixed
        }
        &--fixed {
            position fixed !important
        }
    }

    .ui-popup__overlay {
        position absolute

        +layout-sm() {
            position fixed
        }
        &--fixed {
            position fixed
            background-color rgba(0, 0, 0, 0.4)
            & >>> * {
                display none !important
            }
        }
    }

    .ui-popup {
        position: relative;
        display: inline-block;
        z-index: 1200
        text-align: center;
        top: 0;
        bottom: 0;
        border-radius: 8px;
        transform-origin: center center;
        transition: opacity 0.6s ease, transform 0.4s ease
        backface-visibility: hidden
        will-change: opacity, transform, left, top
        min-width: 280px
        height: 100%
        padding: 4.4rem 2rem
        box-sizing: border-box
        vertical-align middle

        &::after {
            content ""
            height 100%
            display inline-block
            vertical-align middle
        }

        +layout-sm-and-up() {
            max-width: 1020px
        }

        &__close {
            position absolute
            top 0
            right 0
            width 3.8rem
            height @width
            display inline-flex
            background-color #121258
            font-size 0
            background-image url('~@/assets/icons/cross.svg')
            background-repeat no-repeat
            background-position center
            cursor pointer
            transition background-color 0.3s ease

            &:hover {
                background-color #3665f3
            }

            &:active {
                opacity 0.9
            }
        }

        &__container {
            display inline-block
            vertical-align middle
            position relative
            text-align left
            overflow hidden
        }

        &__body {
            background-color #fff
            color #121258
            padding 3rem 4rem
            +layout-sm() {
                padding 2rem 2.2rem
            }
        }
    }

    .ui-popup-enter-active .ui-popup--scale, .ui-popup-leave-active .ui-popup--scale {
        opacity 0
        transform scale(0)
    }

    .ui-popup-enter-active .ui-popup--fade, .ui-popup-leave-active .ui-popup--fade {
        opacity 0
    }

    .fade-enter-active,
    .fade-leave-active {
        transition opacity 0.6s ease
    }

    .fade-enter,
    .fade-leave-to {
        opacity 0
    }
</style>
